"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var TopicSpecificationSerialiser = require("./../../topics/details/topic-specification-serialiser");
var UpdateConstraintSerialiser = require("./update-constraint-serialiser");
/**
 * Serialiser for {@link UpdateStreamAddTopicRequest}
 */
var UpdateStreamAddTopicRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(UpdateStreamAddTopicRequestSerialiserClass, _super);
    function UpdateStreamAddTopicRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link UpdateStreamAddTopicRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link UpdateStreamAddTopicRequest} to be written
     */
    UpdateStreamAddTopicRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        TopicSpecificationSerialiser.write(bos, value.topicSpecification);
        UpdateConstraintSerialiser.write(bos, value.constraint);
    };
    return UpdateStreamAddTopicRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.UpdateStreamAddTopicRequestSerialiserClass = UpdateStreamAddTopicRequestSerialiserClass;
/**
 * The {@link UpdateStreamAddTopicRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.UpdateStreamAddTopicRequestSerialiser = new UpdateStreamAddTopicRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-add-topic-request-serialiser.js
// module id = 1430
// module chunks = 1